export const MAX_CRAWLING_TIME_MS = 60 * 1000; // This should have the same value as the one in the server @ backend/server/src/website/const.ts
